import { MouseEventHandler } from 'react';

import clsx from 'clsx';

import ImageIcon from '../../icons/ImageIcon';
import { Props as AcadlyToolbarButtonProps } from '../../ToolbarButton';
import { imageUploadButtonClasses, ToolbarButton } from './styles';
import useImageUploadButtonVM, { Props as VMProps } from './vm';

export type Props = VMProps &
  AcadlyToolbarButtonProps & {
    /** allow to upload a single image or multiple image at a time, default true */
    multiple?: boolean;
    classes?: Partial<typeof imageUploadButtonClasses>;
  };

const ImageUploadButton = ({ editorRef, onBeforeImageUpload, multiple = true, classes, ...props }: Props) => {
  const { selectImageRef, allowedImages, handleImageSelect } = useImageUploadButtonVM({
    editorRef,
    onBeforeImageUpload,
  });

  const handleImageButtonMouseDown: MouseEventHandler<HTMLElement> = (event) => {
    event.preventDefault();
  };

  return (
    <ToolbarButton
      {...props}
      onMouseDown={handleImageButtonMouseDown}
      className={clsx(
        imageUploadButtonClasses.toolbarButton,
        classes?.toolbarButton,
        imageUploadButtonClasses.image,
        classes?.image
      )}
    >
      <ImageIcon
        size={16}
        className={clsx(
          imageUploadButtonClasses.toolbarIcon,
          classes?.toolbarIcon,
          imageUploadButtonClasses.imageIcon,
          classes?.imageIcon
        )}
      />
      <label className={clsx(imageUploadButtonClasses.label, classes?.label)}>
        <input
          hidden
          id="test"
          multiple={multiple}
          ref={selectImageRef}
          accept={allowedImages}
          type="file"
          onChange={handleImageSelect}
        />
      </label>
    </ToolbarButton>
  );
};

export default ImageUploadButton;
